export default "__VITE_ASSET__BvLA$368__"